var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonBox = function SvgPersonBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#person_box_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B7CC9",
    d: "M20.8 0H0v24.108L6 19H0h20.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C24 17.48 24 16.92 24 15.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C22.48 0 21.92 0 20.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 3a2.667 2.667 0 1 0 0 5.333h-.667A4.667 4.667 0 0 0 6.667 13c0 .736.597 1.333 1.333 1.333h8c.736 0 1.333-.597 1.333-1.333a4.667 4.667 0 0 0-4.666-4.667H12A2.667 2.667 0 0 0 12 3Zm-1.333 2.667a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0ZM8 13a3.333 3.333 0 0 1 3.333-3.333h1.334A3.333 3.333 0 0 1 16 13H8Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "person_box_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPersonBox;